import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const yesnoDriver = {
  type: 'yesno',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    /** @type {'1' | '0'} */
    let currentValue = ctx.value != null ? (ctx.value === '1' || ctx.value === true || ctx.value === 1 ? '1' : '0') : '0';

    const wrapper = createElement('div', {
      class: 'yesno-driver',
      role: 'group',
      'aria-label': def.label,
    });

    const yesBtn = /** @type {HTMLButtonElement} */ (createElement('button', {
      type: 'button',
      class: 'yesno-driver__btn',
    }, ['Yes']));

    const noBtn = /** @type {HTMLButtonElement} */ (createElement('button', {
      type: 'button',
      class: 'yesno-driver__btn',
    }, ['No']));

    function updateUI() {
      yesBtn.setAttribute('aria-pressed', currentValue === '1' ? 'true' : 'false');
      noBtn.setAttribute('aria-pressed', currentValue === '0' ? 'true' : 'false');
      yesBtn.classList.toggle('yesno-driver__btn--active', currentValue === '1');
      noBtn.classList.toggle('yesno-driver__btn--active', currentValue === '0');
    }

    yesBtn.addEventListener('click', () => {
      if (currentValue !== '1') {
        currentValue = '1';
        updateUI();
        onChange(currentValue);
      }
    });

    noBtn.addEventListener('click', () => {
      if (currentValue !== '0') {
        currentValue = '0';
        updateUI();
        onChange(currentValue);
      }
    });

    wrapper.appendChild(yesBtn);
    wrapper.appendChild(noBtn);
    container.appendChild(wrapper);

    if (def.disabled) {
      yesBtn.disabled = true;
      noBtn.disabled = true;
    }

    updateUI();

    return {
      setValue(value) {
        currentValue = (value === '1' || value === true || value === 1) ? '1' : '0';
        updateUI();
      },
      getValue() {
        return currentValue;
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        wrapper.remove();
      },
      setDisabled(disabled) {
        yesBtn.disabled = disabled;
        noBtn.disabled = disabled;
      },
      clearValue() {
        currentValue = '0';
        updateUI();
      },
      setAriaInvalid(invalid) {
        wrapper.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
